import RibbonText from 'modules/content-cms/components/ribbon-text';
import React from 'react';
import Slider from 'react-slick';
import Button from '../../../../components/button';
import {
    ISectionIngredientsGridFields,
    ISectionIngredientsGridIngredient,
} from '../../../../global';
import ContentContainer from '../components/content-container';
import Image from '../components/image';
import Title from '../components/title';

const IngredientsGrid: React.FC<ISectionIngredientsGridFields> = ({
  backgroundColor,
  title,
  slider,
  ingredients,
  richTitle,
}) => {
  const renderImage = (ingredient: ISectionIngredientsGridIngredient) => {
    if (ingredient.fields.imageLink) {
      return (
        <div
          className="mx-auto w-full rounded-full"
          style={{ maxWidth: '200px' }}
        >
          <a href={ingredient.fields.imageLink}>
            <Image {...ingredient.fields.image} className="rounded-full" />
          </a>
        </div>
      );
    } else {
      return (
        <div
          className="mx-auto w-full rounded-full"
          style={{ maxWidth: '200px' }}
        >
          <Image {...ingredient.fields.image} className="rounded-full" />
        </div>
      );
    }
  };

  const renderIngredient = (ingredient: ISectionIngredientsGridIngredient) => {
    return (
      <>
        {renderImage(ingredient)}

        <div className="mt-6">
          {ingredient.fields.title && (
            <div className="text-sm font-black uppercase leading-loose text-primary-main">
              {ingredient.fields.title}
            </div>
          )}

          <div className="pt-2">{ingredient.fields.text}</div>

          {ingredient.fields.ctaText && ingredient.fields.imageLink && (
            <Button
              href={ingredient.fields.imageLink}
              className="mt-2"
              layout={'brand'}
            >
              {ingredient.fields.ctaText}
            </Button>
          )}
        </div>
      </>
    );
  };

  const sliderSettings = {
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    className: 'pd-ingredient-slider slick--circle-arrow max-width',
    responsive: [
      {
        breakpoint: 798,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <ContentContainer backgroundColor={backgroundColor}>
      {richTitle ? (
        <RibbonText text={richTitle} />
      ) : title ? (
        <Title>{title}</Title>
      ) : null}
      {slider && slider === true ? (
        <Slider {...sliderSettings}>
          {ingredients &&
            ingredients.map((ingredient) => {
              return (
                <div key={ingredient.sys.id}>
                  <div className="w-full px-3 text-center">
                    {renderIngredient(ingredient)}
                  </div>
                </div>
              );
            })}
        </Slider>
      ) : (
        <div className="-mx-3 flex flex-wrap items-start justify-center">
          {ingredients &&
            ingredients.map((ingredient) => (
              <div
                className="w-full px-3 text-center md:w-1/2 lg:w-1/3"
                key={ingredient.sys.id}
              >
                {renderIngredient(ingredient)}
              </div>
            ))}
        </div>
      )}
    </ContentContainer>
  );
};

export default IngredientsGrid;
